import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo4.jpg'


const _withScopeId = n => (_pushScopeId("data-v-01fcc514"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = { style: {"display":"flex","justify-content":"flex-end","padding-top":"8px"} }
const _hoisted_11 = { style: {"display":"none"} }
const _hoisted_12 = {
  id: "barcode",
  class: "oneDelivery",
  style: {"line-height":"24px"}
}
const _hoisted_13 = { class: "deilveryHeader" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "headerLogo",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_15 = { class: "headerTitle" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "伟本智能机电(上海)股份有限公司", -1))
const _hoisted_17 = { class: "headerCode" }
const _hoisted_18 = { class: "middle_first" }
const _hoisted_19 = { class: "middle_one" }
const _hoisted_20 = { class: "middle_two" }
const _hoisted_21 = { class: "middle_seconed" }
const _hoisted_22 = { class: "middle_one" }
const _hoisted_23 = { class: "middle_two" }
const _hoisted_24 = { class: "middle_third" }
const _hoisted_25 = { class: "middle_one" }
const _hoisted_26 = { class: "middle_two" }
const _hoisted_27 = { class: "middle_fourth" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "middle_one" }, "审核码 : 已审核", -1))
const _hoisted_29 = { class: "middle_two" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "middle_fifth" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_two" }, "序号"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_five" }, [
    /*#__PURE__*/_createTextVNode(" 品号 / 调拨数量"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_seven" }, [
    /*#__PURE__*/_createTextVNode(" 品名"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_three" }, [
    /*#__PURE__*/_createTextVNode(" 规格"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_four" }, [
    /*#__PURE__*/_createTextVNode(" 转出仓库"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_four" }, " 转出库位 "),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_four" }, "转入库位"),
  /*#__PURE__*/_createElementVNode("td", { class: "middle_fifth_six" }, "备注")
], -1))
const _hoisted_31 = { class: "middle_fifth_two" }
const _hoisted_32 = { class: "middle_fifth_five" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "middle_fifth_seven" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = { class: "middle_fifth_three" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = { class: "middle_fifth_four" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { class: "middle_fifth_four" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { class: "middle_fifth_four" }
const _hoisted_43 = { class: "middle_fifth_six" }
const _hoisted_44 = { style: {"display":"none"} }
const _hoisted_45 = ["id"]
const _hoisted_46 = { class: "deilvery-header" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-logo",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "伟本智能机电(上海)股份有限公司"),
  /*#__PURE__*/_createElementVNode("p", null, "装配库分拣单")
], -1))
const _hoisted_49 = { class: "header-code" }
const _hoisted_50 = { class: "print-table" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "index-cell" }, "序号")
  ]),
  /*#__PURE__*/_createElementVNode("td", null, "库位编号"),
  /*#__PURE__*/_createElementVNode("td", null, "容器编号"),
  /*#__PURE__*/_createElementVNode("td", null, "品号"),
  /*#__PURE__*/_createElementVNode("td", null, "品号"),
  /*#__PURE__*/_createElementVNode("td", null, "规格"),
  /*#__PURE__*/_createElementVNode("td", null, "单位"),
  /*#__PURE__*/_createElementVNode("td", null, "分拣数")
], -1))
const _hoisted_52 = { class: "drawerIn" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drawerIn1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "图片预览")
], -1))
const _hoisted_54 = { class: "drawerIn2" }
const _hoisted_55 = { style: {"padding":"20px"} }
const _hoisted_56 = { class: "Delivery" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-plus" }, null, -1))
const _hoisted_58 = { class: "dialog-footer" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("确认")

import { onMounted, reactive, ref, nextTick, getCurrentInstance,computed } from "vue";
import {
  BlackPage,
  ordertime,
  simplePrintingX,
  deleteOutDataPage,
  TransferOrderDetails,
  TransferOrderprint,
  shipmentComplete,
  TransferOrderPush,
  TransferExecute,
  AddPrintQuantity,
  TransferOrderImagesUpload
} from "@/service/main/invoices/allocateOrder";
import { getDicListData } from "@/service/main/warehouse/dicWare";
import TableColumnsSelect from "@/components/TableColumnsSelect.vue";
import { downLoadRecordFunction } from "@/service/main/downLoad/index";
import QRCodePrint from "@/components/QRCodePrint.vue";
import DetailDrawer from "./module/DetailDrawer.vue";
import EditModal from "./module/EditModal.vue";
import AddModal from "./module/AddModal.vue";
import infoBlock from "./module/infoBlock.vue";
import { getStatus, getText } from "../switchCase";
import { ElMessage, ElMessageBox, ElLoading, ElTable } from "element-plus";
import QrcodeVue from "qrcode.vue";
import printjs from "print-js";
import { Bottom } from "@element-plus/icons";
import type { UploadProps, UploadUserFile } from "element-plus";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const defaultQuery = {
  OrderNo: "",
  ProjectCode: "",
  dateRange: [],
  OrderStatus: "-10"
  // OrderCategory:"装配调拨单"
};
const pagination = {
  PageNo: 1,
  PageSize: 20
};
// 顶部占位过多 展开/收起
const hidden = ref(false);
const openSearch = () => {
  hidden.value = !hidden.value;
};
const instance = getCurrentInstance();
let tableHeight = ref(0)
// onMounted(() => {
    tableHeight.value = window.innerHeight - 240;
// })
const query = reactive({ ...defaultQuery });
const queried = reactive({ ...pagination });
const selectOptions = reactive({
  status: []
});
const list = ref([]);
const total = ref(0);
const columns = ref([
  {
    label: "状态",
    // width:'120px',
    // fixed:'left',
    scopeName: "orderStatuss",
    show: true
  },
  {
    label: "图片预览",
    // width:'120px',
    // fixed:'left',
    scopeName: "image",
    show: true
  },
  {
    label: "调拨单号",
    // width:'160px',
    field: "orderNo",
    show: true
  },
  {
    label: "项目号",
    field: "projectCode",
    show: true
  },
  {
    label: "单别",
    field: "orderCategory",
    show: true
  },
  {
    label: "单据总数",
    field: "orderQuantityTotal",
    show: true
  },
  // {
  // 	label:'主件品号',
  // 	field:'mainPartNumber',
  // 	show:true
  // },
  // {
  // 	label:'设备编号',
  // 	field:'equipmentNumber',
  // 	show:true
  // },
  {
    label: "制单员",
    width: "180px",
    field: "createdUserName",
    show: true
  },
  {
    label: "创建时间",
    width: "180px",
    field: "createdTime",
    show: true
  },
  {
    label: "更新人",
    field: "updatedUserName"
    //show:true
  },
  {
    label: "更新时间",
    width: "180px",
    field: "updatedTime",
    show: true
  }
]);
const popoverVisible = ref(false);
const fenjianPrintNo = ref("");
const fenjianPrinList = ref([]);
const fenjianPrinyid = ref("");
const detailVisible = ref(false);
const detailId = ref("");
const detailType = ref("");
const detailOrderNo = ref("");
const detailOrderType = ref("");
const editId = ref("");
const editDetails = ref([]);
const mainEdit = ref({});

const editVisible = ref(false);
const editType = ref("");
const addId = ref("");
const addVisible = ref(false);
const addType = ref("");
const printCode = ref("");
const tallyorderList = ref({});
const httpsNum = process.env.VUE_APP_BASE_URL;
const httpValue = httpsNum.indexOf('9093');
// *********************************图片上传*************************
// 图片上传
const actionUrl = computed(
  () => process.env.VUE_APP_BASE_URL + "/api/sysFileInfo/upload"
);
const store = useStore();
const token = computed(() => store.state.login.token);
const headerObj = ref({
  Authorization: `Bearer ${token.value}`
});
// 图片上传窗口默认关闭状态
const drawerImage = ref(false);

// 图片上传调用窗口内部表单的方法
const dialogRef = ref();

const formRules = {
  images: [{ required: true, message: "图片上传不能为空", trigger: "blur" }]
};
// 图片上传窗口中表单数据绑定
const addForm = reactive({
  id: 0,
  images: [] as any
});

const fileList = ref<UploadUserFile[]>([]);

// 关闭图片上传窗口的Close事件
const handleClose = () => {
  // deliverGoodsPlaceShipEnum.value = []
  addForm.images = [];
  fileList.value = [];
  // collectDeliveryPlaceShipEnum.value = []
};

// 移除图片
const handleRemove: UploadProps["onRemove"] = (
  uploadFile: any,
  uploadFiles: any
) => {
  // console.log('uploadFile',uploadFile)
  // console.log('addForm.images',addForm.images)
  const result = addForm.images.findIndex((item: any) => {
    return item == uploadFile.response.data;
  });
  addForm.images.splice(result, 1);
};

//图片上传按钮
const addDeliveryAppointment = (scope: any = {}) => {
  addForm.id = scope.id;
  console.log(scope, "scoped");
  let images = scope.imagesList.filter(
    (item: any) => item != 0 && item != "" && item != undefined && item != null
  );
  if (images.length > 0) {
    addForm.images = images;
    const obj = {
      Id: images
    };
    console.log(obj, "obj");

    downLoadRecordFunction(obj).then((res: any) => {
      console.log(res, "11");
      res.data.forEach((item: any) => {
        let file = {
          response: {
            data: item.fileId
          },
          name: "",
          url: item.url
        };
        fileList.value.push(file);
      });
    });
  }
  drawerImage.value = true;
  nextTick(() => {
    dialogRef.value.clearValidate();
  });
};

//上传成功时候的回调
const handleAvatarSuccess: UploadProps["onSuccess"] = (
  response: any,
  uploadFile: any
) => {
  // console.log('response',response)
  // console.log('uploadFile',uploadFile)
  // console.log('file',fileList)
  if (response.code == 200) {
    addForm.images.push(response.data);
    // console.log('addForm.images',addForm.images)
  } else {
    ElMessage.error(`上传失败${response.code}:${response.message}`);
  }
};

const changeBigPic = ref(false);
const dialogImageUrl = ref("");
// 图片预览
const handlePictureCardPreview: UploadProps["onPreview"] = (
  uploadFile: any
) => {
  // console.log('upload',uploadFile)
  dialogImageUrl.value = uploadFile.url!;
  changeBigPic.value = true;
};

// 上传按钮
const conrirm = () => {
  dialogRef.value.validate((valid: any) => {
    if (valid) {
      console.log(valid, 111);

      TransferOrderImagesUpload(addForm)
        .then((res: any) => {
          getList();
          drawerImage.value = false;
          ElMessage.success("图片上传成功");
          handleClose();
        })
        .catch((err: any) => {
          ElMessage.error(err.message);
        });
    } else {
      ElMessage.warning("未通过校验");
    }
  });
};

// *********************************图片上传*************************

const getStatusOptions = function () {
  getDicListData({ CodeList: "issue_status" })
    .then((d) => {
      selectOptions.status = d.data[0] || [];
    })
    .catch((err) => {
      console.log(err);
    });
};

const onQuery = function () {
  newList();
};

const onReset = function () {
  reset();
};

const newList = function () {
  for (let name in query) {
    if (name === "dateRange") {
      if (query[name] === null || query[name].length === 0) {
        queried.SearchBeginTime = "";
        queried.SearchEndTime = "";
      } else {
        queried.SearchBeginTime = query[name][0] + " 00:00:00";
        queried.SearchEndTime = query[name][1] + " 23:59:59";
      }
    } else {
      queried[name] = query[name];
    }
  }
  for (let name in pagination) {
    queried[name] = pagination[name];
  }
  getList();
};
const singleTableRef = ref();
const getList = function () {
  BlackPage(queried)
    .then((res) => {
      list.value = res.data.rows;
      total.value = res.data.totalRows;
      creatingShipDetail(list.value[0].wareTransferOrderDetails, null);
      singleTableRef.value.setCurrentRow(list.value[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

const reset = function () {
  for (let name in defaultQuery) {
    query[name] = defaultQuery[name];
  }
  newList();
};

const handleSizeChange = function (pageSize) {
  queried.PageNo = 1;
  queried.PageSize = pageSize;
  getList();
};

const handleCurrentChange = function (page) {
  queried.PageNo = page;
  getList();
};

const onGetOnTime = function () {
  ordertime().then((res) => {
    if (res.code == 200) {
      reset();
    }
  });
};
const shipmentCompleted = function (row) {
  shipmentComplete({ id: row.id }).then((res) => {
    if (res.code == 200) {
      getList();
    }
  });
};
const onOpenQRPrint = function (obj) {
  printCode.value = obj.orderNo;
  instance.refs.qrprint.show();
};
const allPrint = function (id) {
  ElMessageBox.confirm("是否确认打印？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      const para = { id: id };
      TransferOrderprint(para).then((res) => {
        tallyorderList.value = res.data;
        console.log(tallyorderList.value, "tallyorderList.value");
      });

      setTimeout(() => {
        printjs({
          printable: "barcode",
          type: "html",
          targetStyles: ["*"]
          // printMode:'auto',
          // onPrintDialogClose: async function() {
          // 	try {
          // 		await ElMessageBox.confirm('是否完成打印？', '提示', {
          // 			confirmButtonText: '完成',
          // 			cancelButtonText: '取消',
          // 			type: 'warning'
          // 		});
          // 		onOpenPrint(id); // 用户点击“完成”后执行
          // 	} catch (err) {
          // 		console.log('用户取消打印或发生错误:', err);
          // 	}
          // }
        });
        // 使用 window.onafterprint 监听打印完成
        // window.onafterprint = function() {
        // 	console.log('打印任务已完成');
        // 	onOpenPrint(id)
        // // 执行其他操作，例如发送通知、记录日志等
        // };
        tallyorderList.value = {};
      }, 100);
      onOpenPrint(id); // 用户点击“完成”后执行
    })
    .catch((err) => {
      console.log(err);
    });
};

const onOpenPrint = function (id) {
  AddPrintQuantity({ id: id }).then((res) => {
    console.log(res);
  });
};

const onPrinFenjian = function (row) {
  if (row.orderStatus !== 0 && row.orderStatus !== undefined) {
    const para = {
      id: row.id
    };
    simplePrintingX(para)
      .then((res) => {
        if (!res.data) {
          ElMessage({
            message: "数据错误",
            type: "warning"
          });
          return false;
        }
        fenjianPrintNo.value = res.data.orderNo;
        fenjianPrinList.value = res.data.sortOrderDetailss || [];

        nextTick(() => {
          printjs({
            printable: fenjianPrinyid.value,
            type: "html",
            scanStyles: false,
            style:
              ".deilvery-header{display:flex}.header-logo,.header-code{flex-shrink:0;}.header-title{flex-grow:1;width:10px;}" +
              ".header-logo img{width: 160px;}.header-title p{text-align:center;}.header-code{padding-right:32px;}.index-cell{width:50px;}" +
              "table.print-table{border:1px solid #333;width:100%;} table.print-table td{border-bottom:1px solid #333;border-right:1px solid #333;}" +
              "table.print-table tr:last-child td{border-bottom:0;}" +
              "table.print-table tr td:last-child{border-right:0;}"
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  } else {
    ElMessage.warning("此单据暂未分拣");
  }
};

const onPush = function (id) {
  // console.log('id',id)
  ElMessageBox.confirm("是否确认推送？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      TransferOrderPush({ id: id }).then((res) => {
        // console.log('res',res)
        getList();
        ElMessage.success("推送成功");
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
const onDel = function (id) {
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      dealDel(id, (f) => {
        if (f) {
          ElMessage.success("删除成功");
          getList();
        }
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
const dealDel = function (id, callback) {
  deleteOutDataPage({ id })
    .then(() => {
      callback && callback(true);
    })
    .catch(() => {
      callback && callback(false);
    });
};
const onOpenExecute = function (id) {
  // console.log('id',id)
  ElMessageBox.confirm("是否确认执行？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      TransferExecute({ id: id }).then((res) => {
        getList();
        ElMessage.success("执行成功");
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
// const onOpenExecute = function(id){
// 	ElMessageBox.confirm('是否确认执行？', '提示', {
// 	  confirmButtonText: '确认',
// 	  cancelButtonText: '取消',
// 	  type: 'warning'
// 	}).then(() => {
// 		TransferExecute(id,(f)=>{
// 			if (f) {
// 				ElMessage.success('执行成功')
// 				getList()
// 			}
// 		})
// 	}).catch((err) => {
// 	  console.log(err)
// 	})
// }

// const onOpenDetail = function(obj,type) {
// 	detailId.value = obj.id
// 	detailType.value = type
// 	detailOrderNo.value = obj.orderNo
// 	detailOrderType.value = obj.orderType
// 	detailVisible.value = true
// }

const onOpenEdit = function (row, type) {
  editDetails.value = [];
  editId.value = row.id;
  editDetails.value = row.wareTransferOrderDetails;
  mainEdit.value = row;
  editType.value = type;
  editVisible.value = true;
};

const onOpenAdd = function (id, type) {
  addId.value = id;
  addType.value = type;
  addVisible.value = true;
};
const onDeatilActionCallback = function () {
  getList();
};

const getOrderDetailInfo = function (params, callback) {
  TransferOrderDetails(params)
    .then((res) => {
      callback && callback(true, res);
    })
    .catch(() => {
      callback && callback(false);
    });
};
//详情
const detailsReset = () => {
  // info.value.detailId = ""
  info.value = [];
  infoShow.value = false;
};
const info = ref([]);
const infoShow = ref(false);

const creatingShipDetail = async function (params: any, column: any) {
  await detailsReset();
  if (column && column.label == "操作") return;
  //console.log('params',params)
  info.value = params.wareTransferOrderDetails;
  infoShow.value = true;
};
onMounted(() => {
  getStatusOptions();
  reset();
});

fenjianPrinyid.value = "fenjian-print-" + new Date().getTime();

//图片预览
const PicturePreview = ref(false);
const PictureVisible = ref("");
const imgnumList = ref([]);
let screenHeight = ref(0);
const pictureview = (scope: any) => {
  console.log("images,", scope);
  screenHeight.value = window.innerHeight - 10;
  if (scope == null) {
    return ElMessage.warning("无图片");
  }
  if (scope.imagesList == null) {
    return ElMessage.warning("无图片");
  }
  let imagesList = scope.imagesList.filter(
    (item: any) => item != 0 && item != "" && item != undefined && item != null
  );
  if (imagesList.length == 0) {
    return ElMessage.warning("无图片");
  }
  imgnumList.value = [];
  PicturePreview.value = true;
  const obj = {
    Id:imagesList
  };
  downLoadRecordFunction(obj).then((res: any) => {
    imgnumList.value = res.data;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _unref(query),
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "出库单号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(query).OrderNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(query).OrderNo) = $event)),
                        clearable: "",
                        placeholder: "请输入出库单号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "项目号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(query).ProjectCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(query).ProjectCode) = $event)),
                        clearable: "",
                        placeholder: "请输入项目号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "制单员:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(query).documentWorker,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(query).documentWorker) = $event)),
                        clearable: "",
                        placeholder: "请输入制单员"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: onQuery
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: onReset
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", {
                        onClick: openSearch,
                        class: "openSearch_Style"
                      }, [
                        _createTextVNode(_toDisplayString(hidden.value ? "收起" : "展开") + " ", 1),
                        _createElementVNode("i", {
                          class: _normalizeClass(hidden.value ? 'el-icon-arrow-up' : 'el-icon-arrow-down')
                        }, null, 2)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (hidden.value)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "状态:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(query).OrderStatus,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(query).OrderStatus) = $event)),
                            placeholder: "请选择状态",
                            style: {"width":"100%"},
                            "popper-append-to-body": false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOptions).status, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (hidden.value)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 1,
                    span: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "创建时间:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _unref(query).dateRange,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(query).dateRange) = $event)),
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "YYYY-MM-DD",
                            style: {"width":"100%"},
                            "append-to-body": false
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (onOpenEdit('', 'add')))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(TableColumnsSelect, {
            list: columns.value,
            "onUpdate:list": _cache[6] || (_cache[6] = ($event: any) => ((columns).value = $event))
          }, null, 8, ["list"])
        ])
      ]),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTable), {
            data: list.value,
            height: _unref(tableHeight),
            border: "",
            "row-key": "id",
            onRowClick: creatingShipDetail,
            ref_key: "singleTableRef",
            ref: singleTableRef,
            "highlight-current-row": "",
            style: {"z-index":"100","overflow":"visible"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString((_unref(queried).PageNo - 1) * _unref(queried).PageSize + (scope.$index + 1)), 1)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (colItem, colIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: 'table-col-' + colIndex
                }, [
                  (colItem.show)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        fixed: colItem.fixed ? colItem.fixed : undefined,
                        width: colItem.width ? colItem.width : undefined,
                        align: colItem.align ? colItem.align : 'center',
                        prop: colItem.field ? colItem.field : undefined,
                        label: colItem.label
                      }, _createSlots({ _: 2 }, [
                        (colItem.scopeName)
                          ? {
                              name: "default",
                              fn: _withCtx((scope) => [
                                (colItem.scopeName === 'orderStatuss')
                                  ? (_openBlock(), _createBlock(_component_el_tag, {
                                      key: 0,
                                      color: _unref(getStatus)(scope.row.orderStatus),
                                      effect: "dark",
                                      style: {"border":"none"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(getText)(scope.row.orderStatus)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"]))
                                  : _createCommentVNode("", true),
                                (colItem.scopeName === 'image')
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "purchaseNoStyle",
                                      onClick: ($event: any) => (pictureview(scope.row))
                                    }, "图片预览", 8, _hoisted_7))
                                  : _createCommentVNode("", true)
                              ])
                            }
                          : undefined
                      ]), 1032, ["fixed", "width", "align", "prop", "label"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "350",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    class: "el-icon-edit",
                    size: "small",
                    onClick: ($event: any) => (onOpenEdit(scope.row, 'modify')),
                    disabled: scope.row.orderStatus !== 0
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  _createVNode(_component_el_button, {
                    class: "el-icon-delete",
                    type: "danger",
                    size: "small",
                    onClick: ($event: any) => (onDel(scope.row.id)),
                    disabled: scope.row.orderStatus !== 0
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "height"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_pagination, {
              background: true,
              total: total.value,
              "current-page": _unref(queried).PageNo,
              "onUpdate:current-page": _cache[7] || (_cache[7] = ($event: any) => ((_unref(queried).PageNo) = $event)),
              "page-size": _unref(queried).PageSize,
              "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => ((_unref(queried).PageSize) = $event)),
              layout: "total, sizes, prev, pager, next, jumper",
              onSizeChange: handleSizeChange,
              onCurrentChange: handleCurrentChange
            }, null, 8, ["total", "current-page", "page-size"])
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(infoBlock, {
        info: info.value,
        visible: infoShow.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((infoShow).value = $event))
      }, null, 8, ["info", "visible"]), [
        [_vShow, infoShow.value]
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("p", null, _toDisplayString(tallyorderList.value.orderCategoryName), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(QrcodeVue, {
                style: {"width":"70px","height":"70px"},
                value: String(tallyorderList.value.id),
                size: 200,
                level: "H"
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("tr", _hoisted_18, [
            _createElementVNode("td", _hoisted_19, " 调拨单别 : " + _toDisplayString(tallyorderList.value.orderCategory) + "（" + _toDisplayString(tallyorderList.value.orderCategoryName) + "） ", 1),
            _createElementVNode("td", _hoisted_20, "工厂 : " + _toDisplayString(tallyorderList.value.factoryCode), 1)
          ]),
          _createElementVNode("tr", _hoisted_21, [
            _createElementVNode("td", _hoisted_22, "调拨单号 : " + _toDisplayString(tallyorderList.value.orderNo), 1),
            _createElementVNode("td", _hoisted_23, " 总数量 : " + _toDisplayString(tallyorderList.value.orderQuantityTotal), 1)
          ]),
          _createElementVNode("tr", _hoisted_24, [
            _createElementVNode("td", _hoisted_25, "单据日期 : " + _toDisplayString(tallyorderList.value.updatedTime), 1),
            _createElementVNode("td", _hoisted_26, "项目编号 : " + _toDisplayString(tallyorderList.value.projectCode), 1)
          ]),
          _createElementVNode("tr", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("td", _hoisted_29, "备注 : " + _toDisplayString(tallyorderList.value.remarks), 1)
          ]),
          _hoisted_30,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tallyorderList.value.wareTransferOrderDetails, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "middle_fifth",
              style: {"border-top":"none"},
              key: index
            }, [
              _createElementVNode("td", _hoisted_31, _toDisplayString(index + 1), 1),
              _createElementVNode("td", _hoisted_32, [
                _createTextVNode(_toDisplayString(item.code) + " / " + _toDisplayString(item.orderQuantity), 1),
                _hoisted_33
              ]),
              _createElementVNode("td", _hoisted_34, [
                _createTextVNode(_toDisplayString(item.name), 1),
                _hoisted_35
              ]),
              _createElementVNode("td", _hoisted_36, [
                _createTextVNode(_toDisplayString(item.specificationModel), 1),
                _hoisted_37
              ]),
              _createElementVNode("td", _hoisted_38, [
                _createTextVNode(_toDisplayString(item.transferToIssue), 1),
                _hoisted_39
              ]),
              _createElementVNode("td", _hoisted_40, [
                _createTextVNode(_toDisplayString(item.transferOutLocation), 1),
                _hoisted_41
              ]),
              _createElementVNode("td", _hoisted_42, _toDisplayString(item.transferredILocation), 1),
              _createElementVNode("td", _hoisted_43, _toDisplayString(item.orderRemark), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", { id: fenjianPrinyid.value }, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createVNode(QrcodeVue, {
                style: {"width":"70px","height":"70px"},
                value: fenjianPrintNo.value,
                level: "H"
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("table", _hoisted_50, [
            _createElementVNode("tbody", null, [
              _hoisted_51,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fenjianPrinList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(item.locationCode), 1),
                  _createElementVNode("td", null, _toDisplayString(item.containerCode), 1),
                  _createElementVNode("td", null, _toDisplayString(item.code), 1),
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(item.specificationModel), 1),
                  _createElementVNode("td", null, _toDisplayString(item.unit), 1),
                  _createElementVNode("td", null, _toDisplayString(item.sortQuantity), 1)
                ]))
              }), 128))
            ])
          ])
        ], 8, _hoisted_45)
      ])
    ]),
    _createVNode(EditModal, {
      visible: editVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((editVisible).value = $event)),
      "order-id": editId.value,
      editDetails: editDetails.value,
      mainEdit: mainEdit.value,
      type: editType.value,
      onLoadInitData: getOrderDetailInfo,
      onCallback: onDeatilActionCallback
    }, null, 8, ["visible", "order-id", "editDetails", "mainEdit", "type"]),
    _createVNode(AddModal, {
      visible: addVisible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((addVisible).value = $event)),
      "order-id": addId.value,
      type: addType.value,
      onLoadInitData: getOrderDetailInfo,
      onCallback: onDeatilActionCallback
    }, null, 8, ["visible", "order-id", "type"]),
    _createVNode(QRCodePrint, {
      code: printCode.value,
      ref: "qrprint"
    }, null, 8, ["code"]),
    _createVNode(_component_el_drawer, {
      modelValue: PicturePreview.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((PicturePreview).value = $event)),
      direction: "rtl",
      size: "30%",
      onClose: _cache[14] || (_cache[14] = ($event: any) => (PicturePreview.value = false)),
      "show-close": false,
      "with-header": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", {
              class: "err",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (PicturePreview.value = false))
            }, "×")
          ])
        ]),
        _createElementVNode("div", {
          class: "farwardSearchStyle",
          style: _normalizeStyle({ height: _unref(screenHeight) + 'px' })
        }, [
          _createElementVNode("div", _hoisted_55, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgnumList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_el_image, {
                  style: {"width":"400px","height":"400px"},
                  src: item.url,
                  fit: "cover"
                }, null, 8, ["src"])
              ]))
            }), 128))
          ])
        ], 4)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: drawerImage.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((drawerImage).value = $event)),
      title: "图片上传",
      width: "50%",
      onClose: handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_58, [
          _createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (drawerImage.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_59
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: conrirm
          }, {
            default: _withCtx(() => [
              _hoisted_60
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, [
          _createVNode(_component_el_form, {
            model: _unref(addForm),
            "label-width": "130px",
            ref_key: "dialogRef",
            ref: dialogRef,
            rules: formRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "图片上传:",
                        prop: "images"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_upload, {
                            "file-list": fileList.value,
                            "onUpdate:file-list": _cache[15] || (_cache[15] = ($event: any) => ((fileList).value = $event)),
                            headers: headerObj.value,
                            "on-success": handleAvatarSuccess,
                            fit: "cover",
                            action: _unref(actionUrl),
                            "list-type": "picture-card",
                            "on-remove": handleRemove,
                            "on-preview": handlePictureCardPreview
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_badge, null, {
                                default: _withCtx(() => [
                                  _hoisted_57
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["file-list", "headers", "action"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})